import React from "react";
import { Row, Col, Container, Table } from "reactstrap";
import { PrismLight as SyntaxHighlighter } from "react-syntax-highlighter";
import jsx from "react-syntax-highlighter/dist/esm/languages/prism/jsx";
import { atomDark as theme } from "react-syntax-highlighter/dist/esm/styles/prism";
import "./Usage.css";

SyntaxHighlighter.registerLanguage("jsx", jsx);

const tableStyle = {
  textAlign: "left"
};

const centerEverything = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignContent: "center"
};

const increasedFontSize = {
  fontSize: "125%"
};

const spanHighlight = {
  color: "cyan",
  fontStyle: "italic"
};

function Usage() {
  return (
    <Container fluid={true} className="Usage">
      <Row className="Usage-row" style={{ marginBottom: "0" }}>
        <h1 id="usage">Usage</h1>
      </Row>
      <Row className="Usage-row">
        <Col sm="4" />
        <Col sm="1" style={centerEverything}>
          <h2
            id="install"
            style={{
              textAlign: "center"
            }}
          >
            Install
          </h2>
        </Col>
        <Col sm="3">
          <SyntaxHighlighter
            language="bash"
            style={theme}
            customStyle={{ textAlign: "center" }}
          >
            {`npm install reactparticles.js`}
          </SyntaxHighlighter>
        </Col>
        <Col sm="4" />
      </Row>

      <h2>Props</h2>
      <Row className="Usage-row">
        <Col sm="3" />
        <Col sm="6">
          <Table id="props">
            <thead>
              <tr>
                <th style={tableStyle}>prop</th>
                <th style={tableStyle}>description</th>
                <th style={tableStyle}>type</th>
                <th style={tableStyle}>required</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={tableStyle}>id</td>
                <td style={tableStyle}>unique identifier</td>
                <td style={tableStyle}>string</td>
                <td style={tableStyle}>yes</td>
              </tr>
              <tr>
                <td style={tableStyle}>config</td>
                <td style={tableStyle}>path to particles configuration file</td>
                <td style={tableStyle}>string</td>
                <td style={tableStyle}>no</td>
              </tr>
              <tr>
                <td style={tableStyle}>style</td>
                <td style={tableStyle}>
                  styles to add or override the default
                </td>
                <td style={tableStyle}>object</td>
                <td style={tableStyle}>no</td>
              </tr>
              <tr>
                <td style={tableStyle}>className</td>
                <td style={tableStyle}>class name to apply to the component</td>
                <td style={tableStyle}>string</td>
                <td style={tableStyle}>no</td>
              </tr>
            </tbody>
          </Table>
        </Col>
        <Col sm="3" />
      </Row>

      <h3 id="default-style">Default style</h3>
      <Row className="Usage-row">
        <Col sm="2" />
        <Col sm="4" style={centerEverything}>
          <p style={increasedFontSize}>
            The following style is applied to each instance so it will
            automatically expand to its parent&#39;s height and width.{" "}
            <span style={spanHighlight}>
              This style can be overridden or expanded
            </span>{" "}
            by passing an object with the values in as the style prop.
          </p>
        </Col>
        <Col sm="4">
          <SyntaxHighlighter
            language="jsx"
            style={theme}
            showLineNumbers={true}
          >
            {`style: {
  position: "absolute" as "absolute",
  display: "block",
  top: "0",
  left: "0",
  height: "100%",
  width: "100%"
 }
`}
          </SyntaxHighlighter>
        </Col>
        <Col sm="2" />
      </Row>

      <h3 id="configuration">Configuration</h3>
      <Row className="Usage-row">
        <Col sm="4" />
        <Col sm="4" style={{ ...increasedFontSize, textAlign: "left" }}>
          <ul>
            <li>
              <p>
                Customize and downloaded your config files from the{" "}
                <a href="http://vincentgarreau.com/particles.js/">
                  particle.js site
                </a>
                .
              </p>
            </li>
            <li>
              <p>
                Place the config file in your public folder and{" "}
                <span style={spanHighlight}>
                  pass the config file path to your component
                </span>
                .
              </p>
            </li>
          </ul>
        </Col>
        <Col sm="4" />
      </Row>

      <h3 id="example-use">Example use</h3>
      <Row className="Usage-row">
        <Col sm="2" />
        <Col sm="4" style={centerEverything}>
          <p style={increasedFontSize}>
            Here I&#39;m overwriting the default style width and height and
            adding a background color and opacity.
          </p>
        </Col>
        <Col sm="4">
          <SyntaxHighlighter
            language={"jsx"}
            style={theme}
            showLineNumbers={true}
          >
            {`import React from "react";
import Particles from "reactparticles.js";

...

  <Particles
    id="config-1"
    config="particles/config-1.json"
    style={{
      width: "50%",
      height: "50%",
      backgroundColor: "green",
      opacity: "0.5"
    }}
    className="particles-class-name"
  />

...
`}
          </SyntaxHighlighter>
        </Col>
        <Col sm="2" />
      </Row>
    </Container>
  );
}

export default Usage;
